"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const popover_1 = require("../styles/popover");
const utils_1 = require("../utils");
const hooks_1 = require("../utils/hooks");
const mixpanel_1 = require("../utils/mixpanel");
const cart_item_1 = __importDefault(require("./cart-item"));
const cost_breakdown_1 = __importDefault(require("./cost-breakdown"));
const header_1 = require("./header");
const loyalty_cart_item_1 = __importDefault(require("./loyalty-cart-item"));
const new_item_footer_1 = __importDefault(require("./new-item-footer"));
const NewItem = ({ cart, onRouting, onClose, type }) => {
    var _a, _b, _c;
    const newLoyaltyItem = cart.lastItemAdded && (0, utils_1.mapOrderPipeLoyaltyToProxy)(cart.lastItemAdded);
    const lastItem = cart.last_cart_item;
    const loyaltyItem = (_a = cart.cart_loyalty_product) !== null && _a !== void 0 ? _a : newLoyaltyItem;
    const clearInterval = (0, hooks_1.useInterval)(onClose, 3000, [lastItem === null || lastItem === void 0 ? void 0 : lastItem.campaign_code, loyaltyItem === null || loyaltyItem === void 0 ? void 0 : loyaltyItem.id]);
    (0, hooks_1.useViewTrackEvent)(mixpanel_1.AddToCartRender, cart);
    if (!lastItem && !loyaltyItem)
        return null;
    const onMouseEnter = () => {
        clearInterval();
    };
    const multipleUnits = (cart === null || cart === void 0 ? void 0 : cart.total_units) > 1;
    return ((0, jsx_runtime_1.jsxs)(popover_1.PopoverContainer, { isReopenOrder: (_c = (_b = cart === null || cart === void 0 ? void 0 : cart.metadata) === null || _b === void 0 ? void 0 : _b.show_reopen) !== null && _c !== void 0 ? _c : false, isNewItem: true, onMouseEnter: onMouseEnter, children: [(0, jsx_runtime_1.jsx)(header_1.Header, {}), type !== 'loyalty' && lastItem && ((0, jsx_runtime_1.jsx)(cart_item_1.default, { item: lastItem, isNewItem: true, onRouting: onRouting, cartType: cart.cart_type, isExpired: false })), type === 'loyalty' && loyaltyItem && ((0, jsx_runtime_1.jsx)(loyalty_cart_item_1.default, { item: loyaltyItem, isNewItem: true, cartType: provider_1.CartType.FLASH_SALES, isExpired: false })), (0, jsx_runtime_1.jsx)("div", { style: { marginBottom: '12px' } }), multipleUnits && (0, jsx_runtime_1.jsx)(cost_breakdown_1.default, { isExpired: false, cart: cart }), (0, jsx_runtime_1.jsx)(new_item_footer_1.default, { cart: cart, onRouting: onRouting })] }));
};
exports.default = NewItem;
